import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/shared/Button';
import { useAuthContext } from '../components/AuthProvider';

const styles = {
	container: 'min-h-screen bg-bgColor flex items-center justify-center px-6 py-8',
	content: 'max-w-2xl w-full text-center',
	errorCode: 'text-[100px] md:text-[200px] font-bold bg-gradient-to-r from-orange to-purple bg-clip-text text-transparent leading-none mb-4',
	title: 'text-4xl md:text-5xl font-semibold text-dark-blue mb-4',
	description: 'text-lg text-gray mb-8 mx-auto',
	buttonContainer: 'max-w-xs mx-auto'
};

const PageNotFoundPage = () => {
	const navigate = useNavigate();

	const handleGoToDashboard = () => {
		navigate('/dashboard');
	};
	const handleGoToLogin = () => {
		navigate('/login');
	};
	const { user } = useAuthContext();

	return (
		<section className={styles.container}>
			<div className={styles.content}>
				<h1 className={styles.errorCode}>404</h1>
				<h2 className={styles.title}>Page Not Found</h2>
				<p className={styles.description}>
					The page you are looking for doesn't exist or has been moved.
				</p>
				<div className={styles.buttonContainer}>
					<Button onClick={user ? handleGoToDashboard : handleGoToLogin}>
						{user ? 'Go to Dashboard' : 'Go to Home'}
					</Button>
				</div>
			</div>
		</section>
	);
};

export default PageNotFoundPage;

